
export default function BeforeAfter() {
  return null;
}
